import {
  CascoContractorCreateBirthday,
  ContractorType
} from '@insurance/api/requests'
import { getAge } from '@shared/utils'
import { Form } from 'antd'
import { useEffect } from 'react'

import { CascoFormValues } from './type'
import { formProps, rangeDriverAge, rangeDriverExperience } from './utils'

export const useModifyDriversInfo = () => {
  const formInstance = Form.useFormInstance()
  const {
    driversProps,
    contractorProps,
    driverAgeProps,
    driverExperienceProps
  } = formProps()

  const drivers = Form.useWatch<CascoFormValues['drivers']>(driversProps.name, {
    preserve: true
  })
  const contractor = Form.useWatch<CascoContractorCreateBirthday>(
    contractorProps.name,
    { preserve: true }
  )

  useEffect(() => {
    const isLegalEntity =
      contractor?.content_type === ContractorType.LEGALENTITY

    const birthAges = [
      !isLegalEntity &&
        contractor?.person?.date_of_birth &&
        getAge(contractor?.person?.date_of_birth),
      ...(drivers || []).map(
        (driver) => driver?.date_of_birth && getAge(driver.date_of_birth)
      )
    ].filter(Boolean) as number[]

    const experiences = [
      !isLegalEntity && contractor?.person?.experience,
      ...(drivers || []).map((driver) => driver?.experience)
    ].filter(Boolean) as number[]

    if (birthAges?.length) {
      const minAge = Math.min(...birthAges)
      formInstance.setFieldValue(driverAgeProps.name, rangeDriverAge(minAge))
    }

    if (experiences?.length) {
      const minExperience = Math.min(...experiences)
      formInstance.setFieldValue(
        driverExperienceProps.name,
        rangeDriverExperience(minExperience)
      )
    }
  }, [
    contractor,
    driverAgeProps.name,
    driverExperienceProps.name,
    drivers,
    formInstance
  ])
}
